export const addItemFromObject = (key, value) => {
    try {
        sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.error("Erro ao salvar no storage:", key, value, e);
    }
};

export const getItem = (key) => {
    try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;

        try {
            return JSON.parse(raw); 
        } catch {
            console.warn("Valor inválido no storage para", key, raw);
            return null; 
        }
    } catch (e) {
        return null;
    }
};

export const removeItem = (key) => {
    try {
        sessionStorage.removeItem(key);
    } catch (e) {
        console.error("Erro ao remover item:", key, e);
    }
};

export const clearStorage = () => {
    try {
        sessionStorage.clear();
    } catch (e) {
        console.error("Erro ao limpar storage:", e);
    }
};
